const MIN_SWIPE_DISTANCE = 40;
const VECTOR = Object.freeze({
  UP: 'UP',
  DOWN: 'DOWN',
  RIGHT: 'RIGHT',
  LEFT: 'LEFT'
});

const getQuadrant = vector => {
  const isUpperHemisphere = vector[1] < 0;
  const isLeftHemisphere = vector[0] < 0;
  if (isUpperHemisphere && isLeftHemisphere) return 2;
  if (isUpperHemisphere && !isLeftHemisphere) return 1;
  if (!isUpperHemisphere && isLeftHemisphere) return 3;
  return 4;
};

const convertToAbsoluteAngle = (vector, vectorDeg) => {
  const quadrant = getQuadrant(vector);
  if (quadrant === 1) return -1 * vectorDeg;
  if (quadrant === 2) return 90 - vectorDeg + 90;
  if (quadrant === 3) return 180 - vectorDeg;
  return 360 - vectorDeg;
};

const getSwipeVectorFromPoints = (start, end) => {
  const vector = [end.x - start.x, end.y - start.y];
  const vectorDeg = convertToAbsoluteAngle(
    vector,
    Math.atan(vector[1] / vector[0]) * (180 / Math.PI)
  );
  if (vectorDeg > 315 || vectorDeg <= 45) return VECTOR.RIGHT;
  if (vectorDeg > 45 && vectorDeg <= 120) return VECTOR.DOWN;
  if (vectorDeg > 120 && vectorDeg <= 210) return VECTOR.LEFT;
  return VECTOR.UP;
};

const getDistanceBetweenPoints = (start, end) =>
  Math.trunc(Math.sqrt((end.x - start.x) ** 2 + (end.y - start.y) ** 2));

export const hasSwipedLeft = (touchStartPos, touchEndPos) =>
  getDistanceBetweenPoints(touchStartPos, touchEndPos) >= MIN_SWIPE_DISTANCE &&
  getSwipeVectorFromPoints(touchStartPos, touchEndPos) === VECTOR.LEFT;

export const hasSwipedRight = (touchStartPos, touchEndPos) =>
  getDistanceBetweenPoints(touchStartPos, touchEndPos) >= MIN_SWIPE_DISTANCE &&
  getSwipeVectorFromPoints(touchStartPos, touchEndPos) === VECTOR.RIGHT;

export const hasSwipedUp = (touchStartPos, touchEndPos) =>
  getDistanceBetweenPoints(touchStartPos, touchEndPos) >= MIN_SWIPE_DISTANCE &&
  getSwipeVectorFromPoints(touchStartPos, touchEndPos) === VECTOR.UP;

export const hasSwipedDown = (touchStartPos, touchEndPos) =>
  getDistanceBetweenPoints(touchStartPos, touchEndPos) >= MIN_SWIPE_DISTANCE &&
  getSwipeVectorFromPoints(touchStartPos, touchEndPos) === VECTOR.DOWN;
